import request from '@/utils/request'

// 获取报告详情
export function getEstimateReportApi (data) {
    return request({
        url: 'product/estimateexam/report',
        method: 'post',
        data: data,
    })
}


// 获取估分列表
export function getEstimateListApi (data) {
    return request({
        url: 'product/estimateexam/get_list',
        method: 'post',
        data: data,
    })
}

// 综合报告
export function getReportPositionApi (data) {
    return request({
        url: 'product/estimateexam/comprehensive',
        method: 'post',
        data: data,
    })
}